import React, { FC } from 'react';

import { Button2, Stack, useDesktop, useMobile } from 'Modules/ui3';

import { DocumentsCommon } from '../DocumentsCommon';
import { useRegistrationsDocuments } from './utils';


export const RegistrationDocuments: FC = () => {
    const documents = useRegistrationsDocuments();
    const isMobile = useMobile();
    const isDesktop = useDesktop();

    return (
        <Stack spacing={isMobile ? 2 : 4}>
            {documents.map(({ checklist, testData, ...props }) => (
                <DocumentsCommon
                    {...props}
                    key={props.title}
                    titleButtons={checklist && (
                        <Button2
                            data-testid={`button-${testData}`}
                            href={checklist}
                            // @ts-ignore
                            target='_blank'
                            rel='noreferrer'
                            variant='stroke'
                            size={isDesktop ? 'small' : isMobile ? 'extraExtraSmall' : 'extraSmall'}
                        >
                            Скачать чек-лист
                        </Button2>
                    )}
                />
            ))}
        </Stack>
    );
};
